import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/risk_assessment_result_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  account_id_eq: {
    column_type: 'belongs_to',
    column_name: 'account',
    extra: {
      model_name: 'Account',
    },
    model_name: 'RiskAssessmentResult',
  },
  account: {
    column_type: 'belongs_to',
    column_name: 'account',
    extra: {
      model_name: 'Account',
    },
    model_name: 'RiskAssessmentResult',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('RiskAssessmentResult', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('RiskAssessmentResult', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
